<div id="orders" class="page-layout simple right-sidebar" fxLayout="row">

    <div class="center" fusePerfectScrollbar>
        <div style="padding: 20px;" class="header primary" fxLayout="column" fxLayoutAlign="center center"
            fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
            <span class="mat-display-1 my-0 my-sm-24 welcome-message"
                [@animate]="{value:'*',params:{x:'50px'}}">{{'DASHBOARD' | translate}}
            </span>
        </div>

        <div class="center">
            <div class="widget-group p-12" style="justify-content: center;" fxLayout="row wrap" fxFlex="100">
                <fuse-widget class="widget" fxLayout="column" fxFlex="100" fxFlex.gt-xs="33" fxFlex.gt-md="33">
                    <div class="fuse-widget-front">
                        <div class="pl-16 pr-8 py-16 h-52" fxLayout="row" fxLayoutAlign="space-between center">
                            <button (click)="openContainerDetailDialog(containerAllList)" mat-icon-button>
                                <mat-icon>visibility</mat-icon>
                            </button>
                        </div>

                        <div class="pb-32" fxLayout="column" fxLayoutAlign="center center">
                            <div class="light-blue-fg font-size-72 line-height-72">
                                {{ containerAllList ? containerAllList.length :'0' }}

                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'CONTAINERS' | translate}}

                            </div>
                        </div>
                    </div>

                </fuse-widget>

                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="33" fxFlex.gt-md="33">
                    <div class="fuse-widget-front">
                        <div class="pl-16 pr-8 py-16 h-52" fxLayout="row" fxLayoutAlign="space-between center">
                            <button (click)="openContainerDetailDialog(fullContainerList)" mat-icon-button>
                                <mat-icon>visibility</mat-icon>
                            </button>
                        </div>
                        <div class="pb-32" fxLayout="column" fxLayoutAlign="center center">
                            <div class="font-size-72 line-height-72" style="color: rgba(164, 45, 26, 255);">
                                {{fullContainerList.length}}
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'FULL_CONTAINERS' | translate}}
                            </div>
                        </div>
                    </div>


                </fuse-widget>

                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column" fxFlex="100"
                    fxFlex.gt-xs="33" fxFlex.gt-md="33">

                    <div class="fuse-widget-front">
                        <div class="pl-16 pr-8 py-16 h-52" fxLayout="row" fxLayoutAlign="space-between center">
                            <button (click)="openContainerDetailDialog(emptyContainerList)" mat-icon-button>
                                <mat-icon>visibility</mat-icon>
                            </button>
                        </div>
                        <div class="pb-32" fxLayout="column" fxLayoutAlign="center center">
                            <div style="color:rgba(44, 110, 70, 255)" class="font-size-72 line-height-72">
                                {{ emptyContainerList.length}}
                            </div>
                            <div class="h3 secondary-text font-weight-500">{{'EMPTY_CONTAINERS' | translate}}
                            </div>
                        </div>
                    </div>

                </fuse-widget>


            </div>
        </div>

        <div class="center p-20">
            <div class="my-20" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap.lt-md="50px" fxLayoutGap="0px"
                fxLayoutAlign="space-around">
                <mat-card fxFlex="45" fxFlex.lt-md="80" class="p-20">
                    <mat-card-title class="custom-card-title m-0">{{'CONTAINER_OCCUPANCY_RATE' | translate}}</mat-card-title>
                    <small class="secondary-text">{{'CONTAINER_OCCUPANCY_RATE_SUBTITLE' | translate}}</small>
                    <div class="p-20">
                            <div id="ContainerOccupancyPieChart">
                                <apx-chart
                                  [series]="containerOccupancyPieChartOptions.series"
                                  [chart]="containerOccupancyPieChartOptions.chart"
                                  [labels]="containerOccupancyPieChartOptions.labels"
                                  [dataLabels]="containerOccupancyPieChartOptions.dataLabels"
                                  [legend]="containerOccupancyPieChartOptions.legend"
                                  [colors]="containerOccupancyPieChartOptions.colors"
                                  [responsive]="containerOccupancyPieChartOptions.responsive"
                                ></apx-chart>
                              </div>
                    </div>
                </mat-card>
                <mat-card fxFlex="45" fxFlex.lt-md="80" class="p-20">
                    <mat-card-title class="custom-card-title m-0">{{'CONTAINER_OCCUPANCY_RATE_OF_REGIONS' | translate}}</mat-card-title>
                    <small class="secondary-text">{{'CONTAINER_OCCUPANCY_RATE_OF_REGIONS_SUBTITLE' | translate}}</small>
                    <div class="p-20">
                        <div>
                            <canvas style="width: 100%;" baseChart [datasets]="barChartData" [labels]="barLabel"
                                chartType="bar" [options]="chartBarOptions"></canvas>
                        </div>
                    </div>
                </mat-card>
            </div>

            <div class="center py-20" name="map-container">
                <mat-card>
                <mat-card-title class="custom-card-title">{{'CONTAINER_OCCUPANCY_RATE_OF_REGIONS' | translate}}</mat-card-title>
                    <div class="content-card">
                        <div class="map-container">
                            <div class="map-frame">
                                <div id="map-dashboard">
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card>
            </div>

            <mat-card style="padding: 0 !important;">
                <div class="p-20 table-select-style" fxLayout="row" fxLayoutAlign="space-between center">
                    <mat-card-title class="custom-card-title" fxFlex="70">{{'CONTAINER_STATUS' | translate}}</mat-card-title>
                </div>
                <div class="p-20 pt-0" style="overflow: auto;" fusePerfectScrollbar>
                    <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px; min-width: 700px;" #table
                        [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}">

                        <ng-container matColumnDef="name">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let device">
                                {{device.name!=null?device.name:"---"}}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="altitude">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>{{'OCCUPANCY' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let device">
                                <div *ngIf="((device.device.deviceLatestStatus?.mesafe|containerMsf:device.altitude:device.deadZone)|number : '1.2-2')<cd25">
                                    <span class="custom-color-green">
                                        {{device.device.deviceLatestStatus!=null?((device.device.deviceLatestStatus.mesafe|containerMsf:device.altitude:device.deadZone)| number : '1.2-2') :"---"}}%
                                    </span>
                                    <img style="width: 25px; height: 25px;" src="assets/img/trash-green.png">
                                </div>
                                <div *ngIf="((device.device.deviceLatestStatus?.mesafe|containerMsf:device.altitude:device.deadZone)|number : '1.2-2')<cd50
                                && ((device.device.deviceLatestStatus?.mesafe|containerMsf:device.altitude:device.deadZone)|number : '1.2-2')>cd25">
                                    <span class="custom-color-yellow">
                                        {{device.device.deviceLatestStatus!=null?((device.device.deviceLatestStatus.mesafe|containerMsf:device.altitude:device.deadZone)| number : '1.2-2') :"---"}}%
                                    </span>
                                    <img style="width: 25px; height: 25px;" src="assets/img/trash-yellow.png">
                                </div>
                                <div *ngIf="((device.device.deviceLatestStatus?.mesafe|containerMsf:device.altitude:device.deadZone)|number : '1.2-2')<cd75
                                && ((device.device.deviceLatestStatus?.mesafe|containerMsf:device.altitude:device.deadZone)|number : '1.2-2')>cd50">
                                    <span class="custom-color-orange">
                                        {{device.device.deviceLatestStatus!=null?((device.device.deviceLatestStatus.mesafe|containerMsf:device.altitude:device.deadZone)| number : '1.2-2') :"---"}}%
                                    </span>
                                    <img  style="width: 25px; height: 25px;" src="assets/img/trash-orange.png">
                                </div>
                                <div *ngIf="((device.device.deviceLatestStatus?.mesafe|containerMsf:device.altitude:device.deadZone)|number : '1.2-2')>cd75">
                                    <span class="custom-color-red">
                                        {{device.device.deviceLatestStatus!=null?((device.device.deviceLatestStatus.mesafe|containerMsf:device.altitude:device.deadZone)| number : '1.2-2') :"---"}}%
                                    </span>
                                    <img  style="width: 25px; height: 25px;" src="assets/img/trash-red.png">
                                </div>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="batarya">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>{{'BATTERY'|translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let device">
                                {{device.device.deviceLatestStatus!=null?((device.device.deviceLatestStatus.batarya|deviceBattery)| number : '1.2-2'):'---'}} %
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="solarEnerjiVoltaj">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>{{'SOLAR_ENERGY_BATTERY'|translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let device">
                                {{device.device.deviceLatestStatus!=null?((device.device.deviceLatestStatus.solarEnerjiVoltaj)/100):'---'}} V
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="sonBaglantiTarih">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>{{'LAST_CONNECTION_DATE'|translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let device">
                                {{device.device.deviceLatestStatus!=null?(device.device.deviceLatestStatus.sonBaglantiTarih|date:'dd.MM.yyyy HH:ss'):"---"}}
                            </mat-cell>
                        </ng-container>


                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                        <mat-row *matRowDef="let device; columns: displayedColumns;" class="order" matRipple>
                        </mat-row>
                    </mat-table>

                    <mat-paginator style="min-width: 700px;" #paginator [length]="paginator.length" [pageSize]="10"
                        [pageSizeOptions]="[10, 50, 100]">
                    </mat-paginator>
                </div>
                <mat-progress-bar [fxShow]="tableLoading" style="border-radius: 10px;" mode="indeterminate">
                </mat-progress-bar>
            </mat-card>


            <!-- <div class="content-card p-20">
                <mat-card style="padding: 0 !important;">
                    <div class="p-20 table-select-style" fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-card-title class="custom-card-title" fxFlex="70">{{'CONTAINER_UNLOADING_REPORT' | translate}}</mat-card-title>
                        <div fxLayout="row" fxLayoutGap="5px" fxLayoutGap.gt-sm="10px">
                            <button mat-mini-fab [matMenuTriggerFor]="menuUnloadingFilter">
                                <mat-icon>tune</mat-icon>
                            </button>
                            <mat-menu #menuUnloadingFilter="matMenu">
                                <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'DEVICE'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="selectUnloadingDevice" multiple>
                                            <mat-option *ngFor="let container of containerAllList"
                                                (click)="onUnloadingDeviceSelect()" [value]="container.deviceId">
                                                {{container.deviceId}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div mat-menu-item style="height: 75px;"  (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'CHOOSE_DATE'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="selectByFilter">
                                            <mat-option (click)="onContainerUnloadingStatusClick('day')" value="day">
                                                {{'TODAY'|translate}}
                                            </mat-option>
                                            <mat-option (click)="onContainerUnloadingStatusClick('week')" value="week">
                                                {{'THIS_WEEK'|translate}}
                                            </mat-option>
                                            <mat-option (click)="onContainerUnloadingStatusClick('month')" value="month">
                                                {{'THIS_MONTH'|translate}}
                                            </mat-option>
                                            <mat-option [matMenuTriggerFor]="menu" value="special">
                                                {{'OTHER'|translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-menu #menu="matMenu">
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'START_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="startpicker" name="startpicker"
                                                    placeholder="{{'START_DATE'|translate}}" [(ngModel)]="StartTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #startpicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'END_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="endRatePicker" name="endRatePicker"
                                                    placeholder="{{'END_DATE'|translate}}" [(ngModel)]="EndTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="endRatePicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #endRatePicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item
                                            (click)="StartTime && EndTime ?onContainerUnloadingStatusClick('special',StartTime,EndTime):$event.stopPropagation()">
                                            OK
                                        </div>
                                    </mat-menu>
                                </div>
                            </mat-menu>
                            <button mat-mini-fab (click)="onReportClick()">
                                <mat-icon>cloud_download</mat-icon>
                            </button>
                        </div>

                    </div>
                    <div class="p-20 pt-0" style="overflow: auto;" fusePerfectScrollbar>
                        <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px; min-width: 700px;" #table
                            [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}">

                            <ng-container matColumnDef="deviceId">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'DEVICE_ID' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.deviceId!=null?device.deviceId:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="date">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'DATE' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.date!=null?device.date :"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="beforeOccupancy">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'BEFORE_OCCUPANCY'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.beforeOccupancy!=null?device.beforeOccupancy:'---'}} %
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="afterOccupancy">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'AFTER_OCCUPANCY'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.afterOccupancy!=null?device.afterOccupancy:'---'}} %
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="count">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'CONTACT_COUNT'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.count!=null?device.count:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="address">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'ADDRESS'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.address!=null?device.address:"---"}}
                                </mat-cell>
                            </ng-container>


                            <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                            <mat-row *matRowDef="let device; columns: displayedColumns;" class="order" matRipple>
                            </mat-row>
                        </mat-table>

                        <mat-paginator style="min-width: 700px;" #paginator [length]="paginator.length" [pageSize]="10"
                            [pageSizeOptions]="[10, 50, 100]">
                        </mat-paginator>
                    </div>
                    <mat-progress-bar [fxShow]="tableLoading" style="border-radius: 10px;" mode="indeterminate">
                    </mat-progress-bar>
                </mat-card>

            </div>


            <div class="content-card p-20">
                <mat-card style="padding: 0 !important;">
                    <div class="p-20 table-select-style" fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-card-title class="custom-card-title" fxFlex="70">{{'Konteyner Boşaltım Oran Raporu' | translate}}</mat-card-title>
                        <div fxLayout="row" fxLayoutGap="5px" fxLayout.gt-sm="10px">
                            <button mat-mini-fab [matMenuTriggerFor]="menuUnloadingRateFilter">
                                <mat-icon>tune</mat-icon>
                            </button>
                            <mat-menu #menuUnloadingRateFilter="matMenu">
                                <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'DEVICE'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="selectUnloadingRateDevice" multiple>
                                            <mat-option *ngFor="let container of containerAllList" (click)="onUnloadingRateSelect()"
                                                [value]="container.deviceId">{{container.deviceId}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div mat-menu-item style="height: 75px;"  (click)="$event.stopPropagation();">
                                    <mat-form-field class="w-100-p" appearance="outline">
                                        <mat-label>{{'CHOOSE_DATE'|translate}}</mat-label>
                                        <mat-select [(ngModel)]="selectByRateFilter">
                                            <mat-option (click)="onContainerUnloadingEmptyFullRateClick('day')" value="day">
                                                {{'TODAY'|translate}}
                                            </mat-option>
                                            <mat-option (click)="onContainerUnloadingEmptyFullRateClick('week')" value="week">
                                                {{'THIS_WEEK'|translate}}
                                            </mat-option>
                                            <mat-option (click)="onContainerUnloadingEmptyFullRateClick('month')" value="month">
                                                {{'THIS_MONTH'|translate}}
                                            </mat-option>
                                            <mat-option [matMenuTriggerFor]="menuRate" value="special">
                                                {{'OTHER'|translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-menu #menuRate="matMenu">
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'START_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="startRatePicker" name="startRatePicker"
                                                    placeholder="{{'START_DATE'|translate}}" [(ngModel)]="StartRateTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="startRatePicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #startRatePicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item style="height: 75px;" (click)="$event.stopPropagation();">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>{{'END_DATE'|translate}}</mat-label>
                                                <input matInput [ngxMatDatetimePicker]="endRatepicker" name="endpicker"
                                                    placeholder="{{'END_DATE'|translate}}" [(ngModel)]="EndRateTime" required>
                                                <mat-datepicker-toggle matSuffix [for]="endRatepicker"></mat-datepicker-toggle>
                                                <ngx-mat-datetime-picker #endRatepicker>
                                                    <ng-template>
                                                        <span>OK</span>
                                                    </ng-template>
                                                </ngx-mat-datetime-picker>
                                            </mat-form-field>
                                        </div>
                                        <div mat-menu-item
                                            (click)="StartRateTime && EndRateTime ?onContainerUnloadingEmptyFullRateClick('special',StartRateTime,EndRateTime):$event.stopPropagation()">
                                            OK
                                        </div>
                                    </mat-menu>
                                </div>
                            </mat-menu>
                            <button mat-mini-fab (click)="onReportRateClick()">
                                <mat-icon>cloud_download</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div class="px-20 pb-20 w-100-p">
                        <div id="FullEmptyPieChart">
                            <apx-chart
                              [series]="fullEmptyPieChartOptions.series"
                              [chart]="fullEmptyPieChartOptions.chart"
                              [labels]="fullEmptyPieChartOptions.labels"
                              [legend]="fullEmptyPieChartOptions.legend"
                              [colors]="fullEmptyPieChartOptions.colors"
                              [responsive]="fullEmptyPieChartOptions.responsive"
                            ></apx-chart>
                          </div>
                    </div>
                    <div class="p-20 pt-0" style="overflow: auto;" fusePerfectScrollbar>
                        <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px; min-width: 700px;" #table
                            [dataSource]="dataSourceRate" #sortRate="matSort" matSort [@animateStagger]="{value:'50'}">

                            <ng-container matColumnDef="deviceId">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'DEVICE_ID' | translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.deviceId!=null?device.deviceId:"---"}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="emptyOccupancyCount">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'EMPTY_UNLOADING_COUNT'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.emptyOccupancyCount!=null?device.emptyOccupancyCount:'---'}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="fullOccupancyCount">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'FULL_UNLOADING_COUNT'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.fullOccupancyCount!=null?device.fullOccupancyCount:'---'}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="emptyRate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'EMPTY_UNLOADING_RATE'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.emptyRate!=null?(device.emptyRate | number : '1.2-2'):'---'}} %
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="fullRate">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'FULL_UNLOADING_RATE'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.fullRate!=null?(device.fullRate | number : '1.2-2'):'---'}} %
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="count">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TOTAL_UNLOADING_COUNT'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.count!=null?device.count:'---'}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="address">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'ADDRESS'|translate}}
                                </mat-header-cell>
                                <mat-cell *matCellDef="let device">
                                    {{device.address!=null?device.address:"---"}}
                                </mat-cell>
                            </ng-container>


                            <mat-header-row *matHeaderRowDef="displayedColumnsRate; sticky:true"></mat-header-row>
                            <mat-row *matRowDef="let device; columns: displayedColumnsRate;" class="order" matRipple>
                            </mat-row>
                        </mat-table>

                        <mat-paginator style="min-width: 700px;" #paginatorU [length]="paginatorU.length" [pageSize]="10"
                            [pageSizeOptions]="[10, 50, 100]">
                        </mat-paginator>
                    </div>
                </mat-card>

            </div> -->
        </div>

    </div>
</div>